import { IllustrationOpeningAnimation } from "@assets/IllustrationOpeningAnimation";
import { DoorUnlockPolling } from "@components/Polling/DoorUnlockPolling";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import type { ReactNode } from "react";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

type DoorOpeningScreenProps = {
	unlockRequestId: string;
	accessToken?: string;
	header?: ReactNode;
	onOpened: () => void;
	onClosed?: () => void;
	onExit?: () => void;
};

export function DoorOpeningScreen(props: DoorOpeningScreenProps) {
	const { unlockRequestId, accessToken, header, onOpened, onClosed, onExit } = props;
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer className="px-6">
			<div className="-mx-6">{header ?? <AppHeader showHelpButton={true} />}</div>
			<DoorUnlockPolling
				unlockRequestId={unlockRequestId}
				accessToken={accessToken}
				target="opened"
				onExit={onExit}
				onTerminate={(outcome) => {
					if (outcome.type === "opened") {
						onOpened();
						return;
					}
					// Timeouts and errors are handled inside DoorUnlockPolling (retry panel).
					if (outcome.type === "closed") (onClosed ?? onOpened)();
				}}
			>
				{() => (
					<>
						<h1 className="text-2xl font-breit">
							<T>{i18n.OPENING_DOOR_FOR_YOU()}</T>
						</h1>
						<p className="text-sm text-muted-foreground">
							<T>{i18n.OPENING_DOOR_DESC()}</T>
						</p>
						<div className="flex h-[468px] items-center justify-center">
							<IllustrationOpeningAnimation className="w-[163px]" />
						</div>
					</>
				)}
			</DoorUnlockPolling>
		</PageContainer>
	);
}
